<template>
  <div class="home-page">
    <!-- 顶部轮播图 -->
    <Slides :swiper-list="swiperList" />
    <!-- 中间详情Tab -->
    <fixed-top-wrap>
      <div class="course-introduce-btn">
        <div :class="`btn-context ${tabIndex == index ? '':'gray-btn'}`"
             v-for="(item,index) in productInfo.detail"
             :key="index"
             @click="checkCourseInfo(index)">
          <img class="btn-icon"
               v-if="tabIndex == index"
               :src="imgUrl + 'dz.png'" />
          <div>{{tabList[index]}}</div>
        </div>
      </div>
    </fixed-top-wrap>
    <!-- 下方详情 -->
    <img v-for="(item,index) in productInfo.detail[tabIndex] && productInfo.detail[tabIndex].content"
         :key="index"
         :src="item.url"
         class="course-detail" />
    <!-- 底部按钮 -->
    <div class="page-bottom">
      <div v-if="coupon" class="coupon-tip">
        <div class="info">
          <div v-if="timeLeft>0" class="time">
            <p>距过期仅剩：</p>
            <p>{{ timeLeftStr }}</p>
          </div>
          <div>
            <p class="coupon-price">{{ coupon.price }}元</p>
          </div>
        </div>
        <p class="badge">现金劵已立减</p>
      </div>
      <div class="actions">
        <template v-if="isHbfq">
          <div class="bottom-btn"
              @click="createOrder()">
            <div class="bottom-btn-price">{{productPrice | priceFilter}}</div>
            <div class="bottom-btn-text">立即购买</div>
          </div>
          <div class="bottom-huabei" @click="createOrder('hbfq')">
            <div class="bottom-btn-price">￥{{ hbfqPrice / 100 }}<span>/期起</span></div>
            <div class="bottom-btn-text">分期购买<span v-if="maxFreeRateNum > 0">({{maxFreeRateNum}}期免息）</span></div>
          </div>
        </template>
        <div class="bottom-btn2" v-else
            @click="createOrder()">
          <div class="bottom-btn-price">{{productPrice | priceFilter}}</div>
          <div class="bottom-btn-text">立即购买</div>
        </div>
      </div>
    </div>    
    <!-- 右下方悬浮按钮 -->
    <img class="order-entry"
         :src="imgUrl + 'horder.png'"
         :class="{ 'float-entry-withcoupon': coupon }"
         @click="orderEntry" />
    <div class="service-entry"
        :class="{ 'float-entry-withcoupon': coupon }"
         @click="$refs.serveDialog.show()">
      <img :src="imgUrl + 'kf.png'"
           class="service-icon" />
      <div>咨询</div>
    </div>

    <ServeDialog ref="serveDialog"
                 :cellphone="cellphone"></ServeDialog>

    <Dialog ref="orderDialog"
            @confirm="checkOrderDetail"
            @cancel="$refs.orderDialog.hide()"
            :type="2" />
    <RelationProductDialog ref="relationProductDialog" :products="relationProducts" :productId="productId" @confirm="createRelationOrder"></RelationProductDialog>
  </div>
</template>
<script>
import ProductApi from "api/ProductApi";
import OrderApi from "api/OrderApi"
import Slides from "@/components/Slides";
import Dialog from "@/components/Dialog";
import FixedTopWrap from "@/components/FixedTopWrap";
import ServeDialog from "@/components/ServeDialog";
import RelationProductDialog from "@/components/RelationProductDialog";
import { wexinPay } from "assets/enjory.js";
import UserApi from 'api/UserApi';
import store from '../store/index';

export default {
  components: {
    Slides,
    Dialog,
    FixedTopWrap,
    ServeDialog,
    RelationProductDialog
  },
  data() {
    return {
      imgUrl: 'https://sc2.hexiaoxiang.com/h5/purchase/img/',
      productInfo: {
        detail: []
      }, // 商品信息
      productId: 0,
      swiperList: [],
      tabIndex: 0,
      productPrice: 0, // 商品价格
      isServeDialog: false,
      isHaveOrder: false,
      staffId: '', // 链接绑定员工
      cellphone: "", // 服务热线
      unpaidOrder: "", // 未付款订单ID
      tabList: ["课程介绍", "课程目录", "家长评价"],
      hasRelation: false,
      relationProducts: [],
      payMode: '',
      coupon: null,
      timeLeft: 0,
      timeLeftStr: null
    }
  },
  created() {
    this.productId = this.$route.query.productId;
    // 在首页接受并缓存链接绑定的员工ID
    this.staffId = this.$route.query.staff_id || localStorage.getItem('staffId') || 0;
    localStorage.setItem('staffId', this.staffId);
    this.getProductInfo();
    this.getServiceCellphone();
    this.actionReport();
    this.getCoupon();

    this.$once('onHasRelation', () => {
      this.getRelationProducts();
    });
  },
  computed: {
    // 是否支持花呗分期
    isHbfq() {
      if (!this.productInfo || !this.productInfo.pay_info) {
        return false;
      }

      const { support_hb_fq } = this.productInfo.pay_info
      return support_hb_fq == 1
    },

    // 花呗分期每期价格，包含手续费
    hbfqPrice() {
      if (!this.isHbfq) {
        return;
      }

      let { real_price } = this.productInfo
      const { support_hb_fq, fq_free_rate_nums, hb_fq_nums, hb_fq_rate, hb_fq_seller_percent } = this.productInfo.pay_info
      let maxFqNum = this.maxFqNum
      let rate = hb_fq_rate[maxFqNum]

      //如果分期有free
      if (fq_free_rate_nums.find(e => { return e == maxFqNum })) {
        rate = 0
      }

      if (maxFqNum < 3) {
        return real_price
      }

      let price = (real_price - real_price % maxFqNum) / maxFqNum
      if (price < 1) {
        return real_price
      }

      let totalFee = real_price * rate
      let fee = (totalFee - totalFee % maxFqNum) / maxFqNum
      return price + fee
    },

    maxFreeRateNum() {
      if (!this.isHbfq) {
        return;
      }

      const { fq_free_rate_nums } = this.productInfo.pay_info
      return (fq_free_rate_nums && fq_free_rate_nums.length) ? Math.max(...fq_free_rate_nums) : 0
    },

    maxFqNum() {
      if (!this.isHbfq) {
        return;
      }

      const { hb_fq_nums } = this.productInfo.pay_info
      return (hb_fq_nums && hb_fq_nums.length) ? Math.max(...hb_fq_nums) : 0
    }    
  },
  methods: {
    getRelationProducts() {
       ProductApi.getRelationProducts({
        series_number: this.productId
      }).then(res => {
        const { assemble_product } = res.data
        this.relationProducts = assemble_product
      })      
    },

    // 虚拟优惠劵
    getCoupon() {
      const id = this.$route.query.vcoupon;
      if (id) {
        OrderApi.getVirtualCoupon({
          id,
        }).then((res) => {
          if (res.code !== 20000) {
            console.log('vcoupon fetch error');
            return;
          }
          this.coupon = res.data;
          if ( this.coupon.status === 1) {
            const vm = this;
            setInterval(() => {
              const cur = vm.coupon.expireTime || 0;
              const now = new Date().getTime();
              const leftTime = cur - now;
              if (cur > 0 && leftTime > 0) {
                vm.timeLeft = leftTime;
                const d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                const h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                const m = Math.floor((leftTime / 1000 / 60) % 60);
                const s = Math.floor((leftTime / 1000) % 60);
                const hour = h > 9 ? h : '0' + h;
                const min = m > 9 ? m : '0' + m;
                const sec = s > 9 ? s : '0' + s;
                vm.timeLeftStr = `${d}天${hour}小时${min}分${sec}秒`; // xx天xx小时xx分xx秒
              } else {
                vm.timeLeft = 0;
              }
            }, 1000);
          }
        });
      }

    },

    // 获取商品详情
    getProductInfo() {
      ProductApi.getProductDetail({
        series_number: this.productId
      }).then(res => {
        const { cover, real_price, unpaid_master_order_flag, unpaid_out_trade_no, shareId, has_relation } = res.data
        this.productInfo = res.data
        this.swiperList = cover ? cover.normal_cover : []
        this.productPrice = real_price
        this.unpaidOrder = unpaid_out_trade_no
        this.hasRelation = (has_relation == 1)

        if (this.hasRelation) {
          this.$emit('onHasRelation')
        }

        document.title = res.data.title;
        unpaid_master_order_flag && this.$refs.orderDialog.show()
        const { share_image, share_plans, share_title } = cover ? cover.share : {share_image : '', share_plans : '', share_title : ''}
        this.enjory(
          "share",
          {
            title: share_title,
            link: `https://${location.host}/writeshop/purchase.html#/?staff_id=${this.staffId}&productId=${this.productId}&shareId=${shareId}`,
            imageUrl: share_image,
            desc: share_plans
          });
      })
    },
    // 登录成功后上报
    actionReport() {
      if (!store.state.key || store.state.key === '') {
        console.log('提示：未登录，埋点无法上报');
        return;
      }

      const param = {
        project_type: 1,
        action_type: 3,
        biz_source: `https://${location.host}/writeshop/purchase.html#/?staff_id=${this.staffId}&productId=${this.productId}`
      };
      UserApi.actionReport(param).then(res => {
        console.log('上报: ', res);
      });
    },
    // 获取客服电话
    getServiceCellphone() {
      ProductApi.getCellPhone({
        staff_id: this.staffId
      }).then(res => {
        this.cellphone = res.data.cellphone
      })
    },
    // 查看订单详情
    checkOrderDetail() {
      this.$router.push({
        name: 'orderDetail',
        query: {
          out_trade_no: this.unpaidOrder
        }
      });
    },
    // 下滑至课程展示
    checkCourseInfo(index) {
      this.tabIndex = index
      const targetTop = document.querySelectorAll(".course-detail")[0].offsetTop
      let nowTop = document.documentElement.scrollTop
      if (nowTop < targetTop) {
        document.documentElement.scrollTop = targetTop - 60
      }
    },
    // 下单
    createOrder(payMode) {
      if (this.hasRelation) {
        this.payMode = payMode
        this.$refs.relationProductDialog.show()
        return
      }

      this.$router.push({
        name: 'createOrder',
        query: {
          productId: this.productId,
          payMode: payMode,
          shareId: this.$route.query.shareId
        }
      });
    },
    createRelationOrder(evt) {
      this.$router.push({
        name: 'createOrder',
        query: {
          productId: evt.series_number,
          payMode: this.payMode,
          shareId: evt.shareId
        }
      });
    },
    // 跳转订单页
    orderEntry() {
      this.$router.push({
        name: 'order'
      });
    }
  },
  filters: {
    priceFilter(val) {
      return val ? "￥" + (val / 100) : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.home-page {
  width: 100%;
  font-size: 0;
  padding-bottom:1.4rem;
  .course-introduce-btn {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 53px;
    .btn-context {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #fe693f;
    }
    .gray-btn {
      color: rgba(45, 46, 63, 1);
    }
    .btn-icon {
      margin-right: 7px;
      width: 11px;
      height: 15px;
    }
  }
  .course-detail {
    width: 100%;
  }
  .page-bottom {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    background: white;
    padding: 10px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    z-index:2;

    .actions {
      height: 76px;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: row;

      .bottom-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;      
      width: 50vw;
      height: 56px;
      color: white;
      background: #FFC309;
      border-radius: 56px 0px 0px 56px;
      .bottom-btn-price {
        line-height: 26px;
        font-size: 18px;
        font-weight: bold;
      }
      .bottom-btn-text {
        line-height: 20px;
        font-size: 14px;
      }
    }

    .bottom-btn2 {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;      
      width: 96vw;
      height: 56px;
      color: #9E531D;
      background: #FFC309;
      border-radius: 56px 56px 56px 56px;
      font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
      .bottom-btn-price {
        line-height: 23px;
        font-size: 16px;
        font-weight: bold;
      }
      .bottom-btn-text {
        line-height: 26px;
        font-size: 18px;
        font-weight: bold;
      }
    }

    .bottom-huabei {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;      
      width: 50vw;
      height: 56px;
      color: white;
      background: #FF7B4C;
      border-radius: 0px 56px 56px 0px;
      .bottom-btn-price {
        line-height: 26px;
        font-size: 18px;
        font-weight: bold;
        span {
          font-size: 14px;
        }
      }
      .bottom-btn-text {
        line-height: 20px;
        font-size: 14px;
      }
    }
    }

    
  }

  .float-entry-withcoupon {
    margin-bottom: 120px;
  }
  .order-entry {
    position: fixed;
    right: 9px;
    bottom: 170px;
    width: 59px;
    height: 55px;
    z-index: 100;
  }
  .service-entry {
    position: fixed;
    right: 9px;
    bottom: 90px;
    width: 56px;
    height: 56px;
    line-height: 17px;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border: 2px solid rgba(255, 107, 25, 1);
    border-radius: 50%;
    z-index: 100;
    font-size: 12px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    .service-icon {
      margin-top: 6px;
      width: 24px;
      height: 24px;
    }
  }

  .coupon-tip {
    color: red;
    border: 1px solid red;
    border-radius: 2px;
    padding: 5px 2px;
    position: relative;
    margin: 0 10px 5px 0;
    font-size: 0.6rem;

    .info {
      margin-top: 1.1rem;
      display: flex;
      font-size: 0.5rem;
      justify-content: space-evenly;
      align-items: flex-start;

      .time {
        line-height: 0.8rem;
      }

      .coupon-price {
        font-size: 1.2rem;
      }
    }

    .badge {
      color: white;
      background-color: red;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 2px 0 2px 0;
      padding: 4px;
    }
  }
}
</style>